import { unflatten } from 'flat';
import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ButtonToolbar, Button, Spinner, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import { getScorecardAnswersData } from '../../../../../../redux/reducers/admin/ScoringReducer';
import ScorecardsAnswersForm from '../../../ScorecardAnswersSheet/components/ScorecardsAnswersForm';


class ActionsInList extends React.Component {
  constructor(props) {
    super(props);
    const { record } = this.props;
    const recordUnflatten = unflatten(record);
    const { _id } = recordUnflatten.params;
    const { mediaContent } = recordUnflatten.params;
    const editLink = `/scorecard/score-content/${mediaContent._id}/${_id}`;
    this.state = {
      id: _id,
      editLink,
      showScorecard: false,
    };

    this.toggleDialog = this.toggleDialog.bind(this);
  }

  toggleDialog(e) {
    e.preventDefault();
    this.setState({ showScorecard: !this.state.showScorecard }, () => {
      if (this.state.showScorecard) {
        this.fetchScorecardData();
      }
    });
  }

  fetchScorecardData() {
    const { dispatch } = this.props;
    dispatch(getScorecardAnswersData(this.state.id));
  }

  render() {
    const {
      editLink,
      showScorecard,
    } = this.state;
    const {
      loading,
      scorecardData,
    } = this.props;
    const isFTCCompliant = scorecardData !== null && typeof scorecardData.data !== 'undefined' ? scorecardData.data.isFTCCompliant : null;
    const includesPaidPromotion = scorecardData !== null && typeof scorecardData.data !== 'undefined' ? scorecardData.data.includesPaidPromotion : null;
    const isOscar = scorecardData !== null && typeof scorecardData.data !== 'undefined' ? scorecardData.data.isOscar : null;
    return (
      <>
        <span>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a title="Preview Scorecard" href="#" onClick={this.toggleDialog}><i className="fas fa-eye" /></a>&nbsp;&nbsp;&nbsp;&nbsp;
          <a title="Edit" href={editLink}><i className="fas fa-edit" /></a>&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
        <Modal
          isOpen={showScorecard}
          toggle={this.toggleDialog}
          style={{ minWidth: '750px' }}
        >
          <ModalHeader toggle={this.toggleDialog} tag="h4">Scorecard Preview</ModalHeader>
          {/* eslint-disable-next-line react/no-danger */}
          <div className="modal__body">
            {!loading && showScorecard && scorecardData && (
              <ScorecardsAnswersForm
                questions={scorecardData.data.scorecard}
                answers={scorecardData}
                view="modal"
                isFTCCompliant={isFTCCompliant}
                includesPaidPromotion={includesPaidPromotion}
                isOscar={isOscar}
                type={scorecardData.data.mediaContent.type}
                mediaContentText={scorecardData.data.mediaContent.contentText}
                mediaContentTranscript={scorecardData.data.mediaContent.transcriptionText || ''}
              />
            )}
            {loading && showScorecard && !scorecardData && (
              <div className="text-center"><Spinner color="primary" size="lg" /></div>
            )}
          </div>
          <ButtonToolbar className="modal__footer">
            <Button className="btn btn-primary btn-sm" onClick={this.toggleDialog}>Close</Button>
          </ButtonToolbar>
        </Modal>
      </>
    );
  }
}
ActionsInList.propTypes = {
  record: PropTypes.objectOf(PropTypes.any).isRequired,
  dispatch: PropTypes.func.isRequired,
  scorecardData: PropTypes.objectOf(PropTypes.any),
  loading: PropTypes.bool,
};

ActionsInList.defaultProps = {
  loading: null,
  scorecardData: null,
};

const mapStateToProps = state => ({
  loading: state.score.loading.fetchScorecardAnswersContent,
  scorecardData: state.score.answers,
});

export default connect(mapStateToProps)(ActionsInList);
